import { configureStore } from "@reduxjs/toolkit";
import AssetReducer from "./reducers/AssetReducer";
import UIReducer from "./reducers/UIReducer";
import WellReducer from './reducers/WellReducer';

export const store = configureStore({
  reducer: {
    ui: UIReducer,
    asset: AssetReducer,
    well: WellReducer
  }
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
